import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import {Common} from '../../lib/common';

export interface MenuPopoverItem {
  name: string,
  icon?: string, // MTIconsFont icon, such as 'mt-check'
  action?: (popover: MenuPopoverComponent) => any,
  hidden?: boolean,
  info?: any     // passed by caller to be used as caller sees fit
}

@Component({
  selector: 'app-menu-popover',
  templateUrl: './menu-popover.component.html',
  styleUrls: ['./menu-popover.component.scss']
})
export class MenuPopoverComponent implements OnInit {

  popoverCtrl: PopoverController
  items: MenuPopoverItem[]
  selectedItem: MenuPopoverItem = null
  selectedIndex = -1
  minWidth: number = 200

  static async present(popoverCtrl: PopoverController, cssClass: string, event: any, items: MenuPopoverItem[], minWidth?: number) {
    const popover = await popoverCtrl.create({
      component: MenuPopoverComponent,
      event: event,
      cssClass: cssClass,
      componentProps: {
        popoverCtrl: popoverCtrl,
        items: items.filter((item: MenuPopoverItem) => !item.hidden),
        minWidth: minWidth || 200
      }
    })

   await popover.present().then(() => Common.ensurePopoverOnScreen())

   await popover.onDidDismiss().then(results => {
      if (results.data && results.data.selectedItem.action) {
        results.data.selectedItem.action(this)
      }
    })
  }

  constructor() { }

  ngOnInit() {
  }

  select(item: MenuPopoverItem) {
    this.selectedItem = item
    this.selectedIndex = this.items.indexOf(item)
    this.popoverCtrl.dismiss(this)
  }

  isDivider(item: MenuPopoverItem): boolean {
    return item.name === '-'
  }

  hasIcon(item: MenuPopoverItem): boolean {
    return item.icon !== undefined
  }

}
